import { Input } from '@listening/frontend/components/radix/input';
import { cn } from '@listening/utils/react-helpers';
import { Eye, EyeClosed } from 'iconoir-react';
import { type ComponentProps, useState } from 'react';
import * as m from '@/paraglide/messages';

export function PasswordInput({
  appearance,
  ...props
}: Omit<ComponentProps<typeof Input>, 'type' | 'rightIcon'> & {
  appearance: 'auth' | 'onboarding';
}) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeClosed : Eye;
  const onboarding = appearance === 'onboarding';

  return (
    <Input
      {...props}
      rightIcon={
        onboarding || props.value ? (
          <button
            aria-label={
              visible ? m.common_hide_password() : m.common_show_password()
            }
            className={
              onboarding
                ? 'flex size-8 items-center justify-center rounded-sm focus-visible:ring-2 focus-visible:ring-azure-595'
                : 'focus:outline-hidden'
            }
            disabled={props.disabled}
            onClick={() => setVisible(!visible)}
            type='button'
          >
            <Icon
              className={cn(
                'size-4 opacity-70 transition-opacity hover:opacity-100',
                onboarding ? 'text-steel-700' : 'text-secondary-foreground',
              )}
            />
          </button>
        ) : null
      }
      type={visible ? 'text' : 'password'}
    />
  );
}
